// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__2fPgC","normal":"Index_normal__1zBFo","normalh5":"Index_normalh5__2eOms","animationFade":"Index_animationFade__14o0I"};